<div class="content-area">
  <div class="title-block">
    <div class="title-block__left">
      <h1>{{title}}</h1>
    </div>
    <div class="title-block__right">
      <a href="javascript:void(0);" class="filter-show-hide" (click)="QuickAction.toggle($event)" pTooltip="Actions"
         tooltipPosition="left">
        <svg width="21" height="5" viewBox="0 0 21 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="2.5" cy="2.5" r="2.5" fill="#707070"></circle>
          <circle cx="10.5" cy="2.5" r="2.5" fill="#707070"></circle>
          <circle cx="18.5" cy="2.5" r="2.5" fill="#707070"></circle>
        </svg>
      </a>

      <p-popover #QuickAction appendTo="body" class="search-filter">
        <div class="quick-link-menu enable-disable-patient">
          <ul>
            <li><a class="invite-schedule" href="javascript:void(0)" (click)="SelectedTherapistSelfScheduleAppointmentStatus(true)">Enable Patient's Self Scheduling</a></li>
            <li><a class="invite-schedule" href="javascript:void(0)" (click)="SelectedTherapistSelfScheduleAppointmentStatus(false)">Disable Patient's Self Scheduling</a></li>
          </ul>
        </div>
      </p-popover>

      <a href="javascript:void(0);" pTooltip="Add Therapist" tooltipPosition="left" class="add-plus"
         routerLink="/admin/therapists/add"><img src="assets/img/add-plus.svg" width="17" alt="filters"></a>

      <a href="javascript:void(0);" pTooltip="Filters" tooltipPosition="right" class="filter-block filter-show-hide"
         (click)="overlyFilter.toggle($event)">
        <img src="assets/img/filter-ic.svg" width="18" alt="filters">
      </a>
    </div>
  </div>

  <div class="page-scroll admin-user">
    <div class="table-outer-main therapist-table">
      <p-table #nsdl class="table-outer" [value]="therapists"
               [paginator]="totalRecords>0?true:false" sortMode="single" sortField="AppUserFname"
               [first]="searchRequestModel.FirstRecordIndex" [sortOrder]="1" [(selection)]="selectedTherapists" selectionMode="" [rows]="getTotalRows()"
               [totalRecords]="totalRecords" [lazy]="true" [customSort]="true" (onLazyLoad)="onLazyLoad($event)"
               [scrollable]="true"
                 scrollHeight="calc(100vh - 200px)" 
               >
        <ng-template pTemplate="header">
          <tr>
            <th pFrozenColumn class="table-outer__th table-checkbox-column">
              <span class="table-checkbox">
                <p-tableHeaderCheckbox #headerCheckBox></p-tableHeaderCheckbox>
              </span>
            </th>
            <th *ngIf="isGroupAppointmentFeatureSubscribed" pFrozenColumn class="table-outer__th therapist-option-icon-column"> &nbsp;</th>
            <th pFrozenColumn class="table-outer__th" pSortableColumn="AppUserLname">
              Therapist<p-sortIcon field="AppUserLname"></p-sortIcon>
            </th>
            <th class="table-outer__th" pSortableColumn="CrmFacilityName">
              Facility<p-sortIcon field="CrmFacilityName"></p-sortIcon>
            </th>
            <th class="table-outer__th" >License State</th>
            <th class="table-outer__th" >Classifications</th>            
            <th class="table-outer__th"  pSortableColumn="dateTimeUserLastLogin">
              Last Login<p-sortIcon field="dateTimeUserLastLogin"></p-sortIcon>
            </th>
            <th class="table-outer__th status-column" pSortableColumn="IsActive">
              Status<p-sortIcon field="IsActive"></p-sortIcon>
            </th>           
            <th class="table-outer__th" pSortableColumn="AppUserRegistrationStatus">
              Registration
              Status<p-sortIcon field="AppUserRegistrationStatus"></p-sortIcon>
            </th>
            <th class="table-outer__th" >Patient's Self Scheduling</th>
            <th pFrozenColumn alignFrozen="right" class="table-outer__th table-dot-column" width="120">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-therapist>
          <tr>
            <td pFrozenColumn class="table-outer__td table-checkbox-column">
              <p-tableCheckbox [value]="therapist"></p-tableCheckbox>
            </td>
            <td *ngIf="isGroupAppointmentFeatureSubscribed" pFrozenColumn class="table-outer__td therapist-option-icon-column">
              <ng-container *ngIf="isGroupAppointmentFeatureSubscribed">
              <svg *ngIf="therapist.enableGroupSession" width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.35 8.82353C10.2517 8.82353 11.1165 9.19538 11.7542 9.85727C12.3918 10.5192 12.75 11.4169 12.75 12.3529V14.1176C12.75 14.3517 12.6604 14.5761 12.501 14.7416C12.3416 14.907 12.1254 15 11.9 15C11.6746 15 11.4584 14.907 11.299 14.7416C11.1396 14.5761 11.05 14.3517 11.05 14.1176V12.3529C11.05 11.8849 10.8709 11.4361 10.5521 11.1051C10.2333 10.7742 9.80087 10.5882 9.35 10.5882H3.4C2.94913 10.5882 2.51673 10.7742 2.19792 11.1051C1.87911 11.4361 1.7 11.8849 1.7 12.3529V14.1176C1.7 14.3517 1.61045 14.5761 1.45104 14.7416C1.29163 14.907 1.07543 15 0.85 15C0.624566 15 0.408365 14.907 0.248959 14.7416C0.0895533 14.5761 0 14.3517 0 14.1176V12.3529C0 11.4169 0.358213 10.5192 0.995837 9.85727C1.63346 9.19538 2.49826 8.82353 3.4 8.82353H9.35ZM14.45 8.82353C15.1263 8.82353 15.7749 9.10242 16.2531 9.59883C16.7313 10.0953 17 10.7685 17 11.4706V13.2353C17 13.4693 16.9104 13.6937 16.751 13.8592C16.5916 14.0247 16.3754 14.1176 16.15 14.1176C15.9246 14.1176 15.7084 14.0247 15.549 13.8592C15.3896 13.6937 15.3 13.4693 15.3 13.2353V11.4706C15.3 11.2366 15.2104 11.0121 15.051 10.8467C14.8916 10.6812 14.6754 10.5882 14.45 10.5882H13.2464C12.9524 9.88914 12.4888 9.28112 11.9009 8.82353H14.45ZM6.375 0C7.38945 0 8.36236 0.418329 9.07968 1.16296C9.79701 1.90759 10.2 2.91752 10.2 3.97059C10.2 5.02365 9.79701 6.03359 9.07968 6.77822C8.36236 7.52285 7.38945 7.94118 6.375 7.94118C5.36055 7.94118 4.38764 7.52285 3.67032 6.77822C2.95299 6.03359 2.55 5.02365 2.55 3.97059C2.55 2.91752 2.95299 1.90759 3.67032 1.16296C4.38764 0.418329 5.36055 0 6.375 0ZM13.6 2.64706C14.2763 2.64706 14.9249 2.92594 15.4031 3.42236C15.8813 3.91878 16.15 4.59207 16.15 5.29412C16.15 5.99616 15.8813 6.66945 15.4031 7.16587C14.9249 7.66229 14.2763 7.94118 13.6 7.94118C12.9237 7.94118 12.2751 7.66229 11.7969 7.16587C11.3187 6.66945 11.05 5.99616 11.05 5.29412C11.05 4.59207 11.3187 3.91878 11.7969 3.42236C12.2751 2.92594 12.9237 2.64706 13.6 2.64706ZM6.375 1.76471C5.81142 1.76471 5.27091 1.99711 4.8724 2.41079C4.47388 2.82448 4.25 3.38555 4.25 3.97059C4.25 4.55562 4.47388 5.1167 4.8724 5.53038C5.27091 5.94407 5.81142 6.17647 6.375 6.17647C6.93859 6.17647 7.47909 5.94407 7.8776 5.53038C8.27612 5.1167 8.5 4.55562 8.5 3.97059C8.5 3.38555 8.27612 2.82448 7.8776 2.41079C7.47909 1.99711 6.93859 1.76471 6.375 1.76471ZM13.6 4.41176C13.3746 4.41176 13.1584 4.50473 12.999 4.6702C12.8396 4.83567 12.75 5.0601 12.75 5.29412C12.75 5.52813 12.8396 5.75256 12.999 5.91804C13.1584 6.08351 13.3746 6.17647 13.6 6.17647C13.8254 6.17647 14.0416 6.08351 14.201 5.91804C14.3604 5.75256 14.45 5.52813 14.45 5.29412C14.45 5.0601 14.3604 4.83567 14.201 4.6702C14.0416 4.50473 13.8254 4.41176 13.6 4.41176Z" fill="#868686"/>
              </svg>
              <i *ngIf="!therapist.enableGroupSession" class="pi pi-user" style="font-size: 2rem;color: #64748b;"></i>
              </ng-container>
            </td>
            <td pFrozenColumn class="table-outer__td">
              <span class="link">
                <a (click)="onView(therapist.enUserInfoId)">{{therapist.appUserLname}}, {{therapist.appUserFname}}</a>
              </span>
            </td>
            <td class="table-outer__td">{{therapist.crmFacilityName}}</td>
            <td class="table-outer__td status-column">
              <ng-container *ngIf="therapist.crmState | viewMore as result">
                {{result.textResult }}
                <ng-container *ngIf="result.count>0">
                  <span class="view-more" pTooltip="{{therapist.crmState}}" tooltipStyleClass="large-tooltip-outer">+ {{result.count}}  More</span>
                </ng-container>
              </ng-container>
             
            </td>

            <td class="table-outer__td status-column">
              <ng-container *ngIf="therapist.classifications | viewMore as result">
                {{result.textResult }}
                <ng-container *ngIf="result.count>0">
                  <span class="view-more" pTooltip="{{therapist.classifications}}" tooltipStyleClass="large-tooltip-outer">+ {{result.count}}  More</span>
                </ng-container>
              </ng-container>
            </td>

            <td class="table-outer__td status-column">{{therapist.dateTimeUserLastLogin | date:appDateFormat.dateFormat}} {{therapist.dateTimeUserLastLogin |  date:'shortTime' | lowercase}}</td>
            <td class="table-outer__td">
              <span [ngClass]="therapist.isActive ? 'user-active' : 'user-inactive'">{{therapist.isActive ? 'Active' : 'Inactive'}}</span>
            </td>
            
            <td class="table-outer__td">{{therapist.appUserRegistrationStatus}}</td>
            <td class="table-outer__td">
              <span class="switchBtn">
                <p-inputSwitch class="form__switch" id="{{therapist.crmIsAllowSelfScheduleAppointments}}"
                               [(ngModel)]="therapist.crmIsAllowSelfScheduleAppointments"
                               (onChange)="handleTherapistSelfScheduleAppointmentStatusChange(therapist.appUserInfoId,$event)">
                </p-inputSwitch>
              </span>
            </td>
            <td pFrozenColumn alignFrozen="right" class="table-outer__td table-dot-column">
              <div class="action-column">
                <a class="actionmenu-btn" href="javascript:void(0)"
                   (click)="selectTherapist($event,therapist,therapistsAction)">
                  <svg _ngcontent-nwa-c189="" width="21" height="5" viewBox="0 0 21 5" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <circle _ngcontent-nwa-c189="" cx="2.5" cy="2.5" r="2.5" fill="#707070"></circle>
                    <circle _ngcontent-nwa-c189="" cx="10.5" cy="2.5" r="2.5" fill="#707070"></circle>
                    <circle _ngcontent-nwa-c189="" cx="18.5" cy="2.5" r="2.5" fill="#707070"></circle>
                  </svg>
                </a>
              </div>

              <p-popover appendTo="body" class="table-action-popup therapistsAction NotScheduledAction"
                              #therapistsAction>
                <ul class="quick-link-menu">
                  <li>
                    <a href="javascript:void(0)" class="edit-row" (click)="onEdit(selectedTherapist.enUserInfoId)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="103.901" height="98.574"
                           viewBox="0 0 103.901 98.574">
                        <g id="edit-icon-new" transform="translate(-52.983 -52.983)">
                          <path id="Path_3" data-name="Path 3"
                                d="M323.731,72.125l13.32,13.313ZM332.3,60.4,296.28,96.412a13.319,13.319,0,0,0-3.648,6.8l-3.327,16.653,16.653-3.333a13.305,13.305,0,0,0,6.8-3.641l36.016-36.016A11.655,11.655,0,1,0,332.3,60.4Z"
                                transform="translate(-202.246)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="8" />
                          <path id="Path_4" data-name="Path 4"
                                d="M152.884,117.371v18.115a11.745,11.745,0,0,1-3.745,8.539,13.177,13.177,0,0,1-9.041,3.537H69.769a13.179,13.179,0,0,1-9.042-3.537,11.746,11.746,0,0,1-3.745-8.539V69.066a11.746,11.746,0,0,1,3.745-8.539,13.178,13.178,0,0,1,9.042-3.537H88.95"
                                transform="translate(0 -0.006)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="8" />
                        </g>
                      </svg>
                      Edit
                    </a>
                  </li>
                  <li *ngIf="selectedTherapist?.isActive">
                    <a href="javascript:void(0)" class="delete-row" (click)="onDelete(selectedTherapist.enUserInfoId)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="30" viewBox="0 0 26 30">
                        <g id="delete-icon-new" transform="translate(-3 -1)">
                          <path id="Path_1" data-name="Path 1"
                                d="M24,31H8a3,3,0,0,1-3-3V9A1,1,0,0,1,7,9V28a1,1,0,0,0,1,1H24a1,1,0,0,0,1-1V9a1,1,0,0,1,2,0V28a3,3,0,0,1-3,3Z"
                                fill="#6f64a7" />
                          <path id="Path_2" data-name="Path 2" d="M28,7H4A1,1,0,0,1,4,5H28a1,1,0,0,1,0,2Z"
                                fill="#6f64a7" />
                          <path id="Path_3" data-name="Path 3"
                                d="M20,7a1,1,0,0,1-1-1V3H13V6a1,1,0,0,1-2,0V2a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1V6A1,1,0,0,1,20,7Z"
                                fill="#6f64a7" />
                          <path id="Path_4" data-name="Path 4"
                                d="M16,26a1,1,0,0,1-1-1V11a1,1,0,0,1,2,0V25A1,1,0,0,1,16,26Z" fill="#6f64a7" />
                          <path id="Path_5" data-name="Path 5"
                                d="M21,24a1,1,0,0,1-1-1V13a1,1,0,0,1,2,0V23A1,1,0,0,1,21,24Z" fill="#6f64a7" />
                          <path id="Path_6" data-name="Path 6"
                                d="M11,24a1,1,0,0,1-1-1V13a1,1,0,0,1,2,0V23A1,1,0,0,1,11,24Z" fill="#6f64a7" />
                        </g>
                      </svg>
                      Delete
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" class="history-row" (click)="onViewHistory(selectedTherapist.enUserInfoId)">
                      <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24">
                        <path d="M12,19c-3.9,0-7-3.1-7-7s3.1-7,7-7c2,0,3.9,0.9,5.2,2.3l-1.8,0.3c-0.5,0.1-0.9,0.6-0.8,1.2c0.1,0.5,0.5,0.8,1,0.8
              c0.1,0,0.1,0,0.2,0l4.2-0.8c0.5-0.1,0.9-0.6,0.8-1.2L20,3.5c-0.1-0.5-0.6-0.9-1.2-0.8c-0.5,0.1-0.9,0.6-0.8,1.2l0.3,1.7
              C16.6,4,14.4,3,12,3C8.7,3,5.8,4.8,4.2,7.5c0,0,0,0,0,0c0,0,0,0,0,0C3.4,8.9,3,10.4,3,12s0.4,3.1,1.2,4.5c0,0,0,0,0,0c0,0,0,0,0,0
              C5,17.9,6.1,19,7.5,19.8c0,0,0,0,0,0c0,0,0,0,0,0C8.9,20.6,10.4,21,12,21c0.4,0,0.8-0.3,0.9-0.6C13,20.3,13,20.1,13,20
              c0-0.1,0-0.3-0.1-0.4C12.8,19.3,12.4,19,12,19z" />
                        <circle cx="20" cy="12" r="1" />
                        <circle cx="18.9" cy="16" r="1" transform="rotate(-60 18.928 16)" />
                        <circle cx="16" cy="18.9" r="1" transform="rotate(-30 15.999 18.929)" />
                        <path d="M13,11.6V9c0-0.6-0.4-1-1-1s-1,0.4-1,1v3c0,0.3,0.1,0.5,0.3,0.7l2,2c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3
              c0.4-0.4,0.4-1,0-1.4L13,11.6z" />
                      </svg>
                      History
                    </a>
                  </li>
                </ul>
              </p-popover>

            </td>

          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <ng-container *ngIf="!loading && totalRecords <= 0">
            <tr>
              <td class="no-records-found-therapist" [attr.colspan]="6">
                {{noRecordsFoundMessage}}
              </td>

            </tr>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="paginatorleft" class="table-pagination">
          <span class="table-pagination__records">
            Total Records : &nbsp;<strong> {{totalRecords}}</strong>
          </span>
        </ng-template>
      </p-table>

      <div class="loader-block" *ngIf="loading">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff"
                           animationDuration=".8s">
        </p-progressSpinner>
      </div>
    </div>

  </div>
</div>


<p-popover class="overly-filter" #overlyFilter>
  <div class="overly-filter__outer">
    <h2 class="filter-title">Filters</h2>
     <a href="javascript:void(0);" class="filter-close" (click)="overlyFilter.toggle($event); onClearFilterSearch();">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
        <path d="M18.2116 2.8568L2.78845 18.1432" stroke="#3E3E3E" stroke-width="2.5"/>
        <path d="M18.143 18.2116L2.85657 2.78844" stroke="#3E3E3E" stroke-width="2.5"/>
      </svg>
    </a>

    <div class="overly-filter__scroll">
      <div class="form__group">
        <label class="form__label">Search</label>
        <div class="search-box">
          <input type="text" class="form__control" pInputText placeholder="Therapist" #therapistBox style="width:auto"
                 (keyup.enter)="onSearchButtonClick()">
          <button *ngIf="therapistBox.value !=''" class="clear-btn" type="button" (click)="therapistBox.value =''">
            <i class="ic cancel"></i>
          </button>
          <button class="search-btn" pButton type="button">
            <i class="search-new"></i>
          </button>
        </div>
      </div>
      <div class="form__group" *ngIf="false">
        <label class="form__label">Branch</label>
        <p-select class="form__dropdown select-box" [options]="branchResponseModel" [(ngModel)]="selectedbranch"
                   id="branchDropdown" placeholder="Select Branch" optionLabel="crmBranchName" filter="true"
                   (onChange)="onBranchChange($event)"></p-select>
      </div>
      <div class="form__group">
        <label class="form__label">Status</label>
        <p-select class="form__dropdown select-box" #statusDropdown [options]="therapistStatus" placeholder="Status"
                    [(ngModel)]="selectedStatus" optionLabel="label" filter="true" (onChange)="onStatusChange($event)">
        </p-select>
      </div>
    </div>

    <div class="form__group btn-block">
      <button class="btn btn--primary" (click)="onFilterSearch()">Search</button>
      <a class="btn btn--secondary clear-filter" href="javascript:void(0)"
         (click)="onClearFilterSearch();onFilterSearch();">Clear</a>
    </div>
  </div>
</p-popover>

<p-dialog [(visible)]="ConfirmToChangeSelfScheulingStatus" styleClass="display-close-icon" [modal]="true" appendTo="body" [closable]="false">
  <div class="popup-content-outer confirm-invite-patients">
    <div>
      <div *ngIf="linkedFacilitiesWithCurrentTherapistCount > 0">
        <h2>Therapist(s) Not Allowed for Patient's Self Scheduling</h2>
        <div class="confirm-invite-patients__content-part" *ngIf="isEnableSelfSchedulingForSelected">
          <p>You have selected {{selectedTherapistsCount}} Therapist(s), however you can't enable Patient's Self Scheduling for selected Therapist(s) because the linked Facility(es) of selected Therapist(s) are not enabled for Patient's Self Scheduling yet.</p>
          <p><strong>Please enable below mentioned Facility(es) first to enable Patient's Self Scheduling for Therapist(s).</strong></p>
        </div>

        <div class="popup-table-outer">
          <table class="custom-table">
            <thead>
              <tr>
                <th>Facility Name</th>
                <th>Therapist Name</th>
              </tr>
            </thead>
            <tbody *ngFor="let linkedFacilitiesWithCurrentTherapist of linkedFacilitiesWithCurrentTherapistActiveDetails">
              <tr>
                <td>{{linkedFacilitiesWithCurrentTherapist.linkedFacilities}}</td>
                <td>{{linkedFacilitiesWithCurrentTherapist.appUserLname | titlecase}}, {{linkedFacilitiesWithCurrentTherapist.appUserFname | titlecase}}</td>
              </tr>
            </tbody>

          </table>
        </div>

        <div class="confirm-invite-patients__buttons-box">
          <a href="javascript:void(0)" class="btn btn--primary" (click)="CancelSelfSchedulingChanges(true)">Ok</a>
        </div>
      </div>

      <div *ngIf="linkedFacilitiesWithCurrentTherapistCount == 0">
        <h2>Confirmation of Patient's Self Scheduling</h2>
        <div class="confirm-invite-patients__content-part" *ngIf="!isEnableSelfSchedulingForSelected">
          <p>Are you sure you want to disable Patient's Self Scheduling for Therapist(s)?</p>
        </div>
        <div class="confirm-invite-patients__content-part" *ngIf="isEnableSelfSchedulingForSelected">
          <p>Are you sure you want to enable Patient's Self Scheduling for Therapist(s)?</p>
        </div>

        <div class="confirm-invite-patients__buttons-box">
          <a href="javascript:void(0)" class="btn btn--secondary" (click)="CancelSelfSchedulingChanges(true)">No, Cancel</a>
          <button class="btn btn--primary" (click)="ConfirmSelfSchedulingChanges()">Yes, Confirm</button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
